import { create } from 'zustand';

export const useLoadingStore = create(set => ({
  savingHomeApp: false,
  setSavingHomeApp: savingHomeApp => set({ savingHomeApp }),
}));
